import { Button, Chip, Grid, IconButton, Menu, MenuItem, } from '@material-ui/core';
import { Autorenew, Cake, Description, Event, EventBusy, Group, HomeWork, Mail, MoreHoriz, Phone, Room } from '@material-ui/icons';
import { getAbsenceHoursByStudentIdAndClassroomId, getClassesById, getInfosIndividual, getWorkStudyCycleByTrainingId } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import { useEffect, useState } from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl';
import AffiliateInfo from './Affiliation';
import TableActions from './TableActions';
import Training from './Training';
import { ageCalculator, pluralize, roundToPreviousHalf } from '@webapps/utils';
import { formatPhoneNumber } from 'react-phone-number-input';
import Team from 'components/Icons/Team';
import CandidatsCardDetailSkeleton from './CandidatsCardDetailSkeleton';

/**
 * Composant modal pour déclarer une absence.
 *
 * @param {boolean} props.hideAbsence - Indique si on affiche les heures d'absence du candidat.
 * @returns {JSX.Element} Le composant modal pour déclarer une absence.
 */
const CandidatsCardDetail = ({ item, id, classId, deleteMember, viewMember, addAbsence, contactMember, hideAbsence, handleDownloadStatement, isLoading = false }) => {
  if (isLoading) {
    return <CandidatsCardDetailSkeleton />;
  }

  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const {
    data: info = {},
    refetchInfosIndividual,
    isLoading: isLoadingInfosIndividual,
  } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
  });

  const {
    data: absenceHours = {},
    refetch: refetchAbsenceHours,
    isLoading: isLoadingAbsenceHours,
  } = useQuery(getAbsenceHoursByStudentIdAndClassroomId, {
    key: ['absenceHours', id],
    variables: { studentId: id, classId },
  });



  const [absenceHoursState, setAbsenceHoursState] = useState(0);
  const [currentRefetchAbsenceHours, setCurrentRefetchAbsenceHours] = useState(null);

  const calculateAbsenceHours = (absences) => {
    let totalAbsenceHours = 0;
    absences.forEach((absence) => {
      totalAbsenceHours += absence.totalHours;
    });
    return totalAbsenceHours;
  };

  useEffect(() => {
    if (item?.student?.absences?.length > 0) {
      const totalAbsenceHours = calculateAbsenceHours(item?.student?.absences);
      setAbsenceHoursState(totalAbsenceHours);
    }
  }, [item]);

  const { data: workStudyCycle } = useQuery(getWorkStudyCycleByTrainingId, {
    key: ['workStudyCycle', item?.classroom?.training],
    variables: { id: item?.classroom?.training },
  })


  function formatHoursAndMinutes(hoursDecimal) {
    const heures = Math.floor(hoursDecimal);
    const minutes = Math.round((hoursDecimal - heures) * 60);
    let result = '';
    if (heures > 0) result += `${heures} ${heures > 1 ? 'heures' : 'heure'}`;
    if (minutes > 0) result += (heures > 0 ? ' ' : '') + `${minutes} min`;
    if (!result) result = '0 heure';
    return result;
  }

  function formatDays(hoursDecimal, dailyHours = 7) {
    const days = Math.floor(hoursDecimal / dailyHours);
    const reste = hoursDecimal % dailyHours;
    let result = '';
    if (days > 0) result += days;
    if (reste >= dailyHours / 2) result += (days > 0 ? '.5' : '0.5');
    if (!result) result = '0';
    return `${result} ${parseFloat(result) > 1 ? 'jours' : 'jour'}`;
  }

  return (
    <Grid item xs={12} md={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <div >
        <div style={{ padding: spacing(2.5), borderRadius: 10, backgroundColor: '#FFF' }} >
          <div >
            <div>
              <div className={classes.infoCandidat}>
                <div>
                  <AvatarStudent applicant={item?.student} />
                </div>
                <div
                  className={css({
                    marginLeft: spacing(1.5),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%',
                  })}
                >
                  <div className={classes.divStudent}>
                    <div style={{ display: 'flex' }} className={global.title} >
                      {item?.student?.lastname}{' '}
                      {item?.student?.firstname}
                    </div>
                    <div>
                      <TableActions
                        contactMember={contactMember}
                        deleteMember={deleteMember}
                        id={id}
                        viewMember={viewMember}
                        addAbsence={() => addAbsence(id, refetchAbsenceHours)} // Passer `refetchAbsenceHours`
                        refetchAbsenceHours={refetchAbsenceHours}
                        handleDownloadStatement={handleDownloadStatement}
                        hideAbsence={hideAbsence}
                      />
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)} style={{ marginTop: 0 }}>
                    <Room className={global.infoIcon} />
                    {item?.student?.address?.cityCode}{' '}
                    {item?.student?.address?.city}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Training id={item?.classroom?.training} />
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)}>
                <Team className={global.infoIcon} />
                <div>{item?.classroom?.label}</div>
              </div>
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)}>
                <Mail className={global.infoIcon} />
                <div>{info?.email?.length > 28 ? info?.email.slice(0, 25) + '...' : info?.email}</div>
              </div>
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)}>
                <Phone className={global.infoIcon} />
                <div className={classes.phone}>{info?.phone ? formatPhoneNumber(info?.phone) : 'Non renseigné'}</div>
              </div>
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)} >
                <HomeWork className={global.infoIcon} />
                <div>{item?.student?.team?.business?.name ? item?.student?.team?.business?.name : 'Aucune entreprise'}</div>
              </div>
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)}>
                <EventBusy className={global.infoIcon} />
                {!absenceHours?.total
                  ? "Pas d'absence"
                  : `${formatDays(absenceHours.total)} (${formatHoursAndMinutes(absenceHours.total)} d'absence)`}
              </div>
              <div className={cx(global.infoText, classes.address, classes.duoTextIcon)}>
                <Autorenew className={global.infoIcon} />
                {workStudyCycle?.rythm?.length !== 0 ? workStudyCycle?.rythm : 'Aucun cycle'}
              </div>
              <Grid>
                <Button onClick={() => viewMember(id)}
                  className={css({ marginTop: spacing(2.5), width: '100%', fontWeight: 600 })}
                  style={{ color: '#5A6DA1', padding: spacing(1) }}
                  variant='outlined'
                >
                  Voir les détails
                </Button>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  )
}

const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%', marginBottom: 16 },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    marginTop: spacing(0.5),
    display: 'flex',
    // alignItems: 'center',
    '@media (max-width: 430px)': {
      flexDirection: 'column'
    }
  },
  duoTextIcon: {
    display: 'flex',
    alignItems: 'center',

  },
  phone: {
    textDecoration: 'none',
    color: '#5A6DA1',
  },
  chip: {
    marginTop: spacing(2),
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  }
});

export default CandidatsCardDetail